import { useEffect } from 'react';
import HeaderMetedBase from './HeaderMetedBase';

import { connect, useDispatch } from 'react-redux'
import { getCatalog } from '../../actions'
import Loading from './Loading';
import AbsorbSupportInfo from './AbsorbSupportInfo';
import AbsorbSupportInfoES from './AbsorbSupportInfoES';


function CatalogController(props) {
    
    const { viewer } = props

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return <BrowseContainer  viewer={viewer}  />

}

const BrowseContainer = (props) => {

    const { viewer } = props;
    const { locale } = viewer.language;

    return (
        <div id='et-browse-container'>

            <HeaderMetedBase activePage="catalog" />
            { locale === "es_ES"
            ?<AbsorbSupportInfoES />
            : <AbsorbSupportInfo />
            }
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        viewer: state.viewer,
        user: state.user,
    };
}

export default connect(mapStateToProps)(CatalogController);